// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"ok_a pz_rs pz_of pz_st"};